import { MetaAdsAdAccount } from '../Types'
import { Button } from 'blaze-ui/Button'
import { Text } from 'blaze-ui/Text/Text'
import Styles from '../MetaAdsAccountSetupModal.module.scss'
import { SuccessTag } from '../SuccessTag/SuccessTag'
import { getCurrencySymbol } from 'components/Wizards/MetaAdCampaignWizard/utils'
import { useMemo } from 'react'

export const AdAccountCard = ({
  account,
  isSelected,
  onSelect,
}: {
  account: MetaAdsAdAccount
  isSelected: boolean
  onSelect: () => void
}) => {
  const accountInfo = account.additional_data ?? {}
  const spentAmount = parseInt(accountInfo.amount_spent ?? '0', 10)
  const currency = accountInfo.currency ?? 'USD'
  const currencyOffset = accountInfo.currency_offset ?? 100
  const businessName = accountInfo.business_name ?? account.name
  const businessId = accountInfo.business_id

  const currencySymbol = useMemo<string>(() => getCurrencySymbol(currency), [currency])
  const formattedSpentAmount = useMemo<string>(() => {
    return `${currencySymbol}${(spentAmount / currencyOffset).toFixed(2)}`
  }, [currencyOffset, currencySymbol, spentAmount])

  return (
    <div className={Styles.card}>
      <div className={Styles.cardLeft}>
        <input
          type="radio"
          name="adAccount"
          value={account.provider_id}
          checked={isSelected}
          onChange={onSelect}
          aria-label={`Select Ad Account ${account.name}`}
          className={Styles.radioInput}
        />
        <div className={Styles.accountInfo}>
          <Text variant="primary" fontWeight="600">
            {account.name}
          </Text>

          <Text variant="secondary">
            <div className={Styles.secondaryAccountInfo}>
              {formattedSpentAmount} Spent {businessId ? `Business: ${businessName} (${businessId})` : ''}
            </div>
          </Text>
        </div>
      </div>
      <div className={Styles.cardRight}>
        {isSelected ? (
          <SuccessTag text="Selected" />
        ) : (
          <Button variant="ghost" size="sm" onPress={onSelect}>
            Use This Account
          </Button>
        )}
      </div>
    </div>
  )
}
